<card-expanding
  [formGroup]="form"
  [valid]="cardValidType"
  [expanded]="isExpanded"
  (onExpand)="saveLocalExpandedValue($event)"
>
  <span header-title>{{ title | translate }}</span>

  <div header-actions *requiredRights="[UserAction.ManageProducts]">
    <ng-container *ngIf="isOwnProduct">
      <ng-container *ngIf="!locked">
        <lxm-button
          *ngIf="!edit"
          type="beige"
          icon="edit"
          title="action.edit"
          (click)="toggleEdit()"
        ></lxm-button>
        <lxm-button
          *ngIf="edit"
          type="grey"
          icon="back"
          label="action.cancel"
          (click)="toggleEdit()"
        >
        </lxm-button>
        <lxm-button
          *ngIf="edit"
          type="beige"
          icon="save"
          label="action.save"
          [loading]="saveLoading"
          (click)="save()"
          buttonType="submit"
        ></lxm-button>
      </ng-container>
      <locked-info *ngIf="locked" [locked]="locked"></locked-info>
    </ng-container>
  </div>

  <div body>
    <div class="grid w-full grid-cols-1 gap-4 xl:grid-cols-2">
      <div class="flex flex-col">
        <form-field
          [readonly]="!edit"
          label="cards.products.product_medication_info.label.atc_segment"
          description="cards.products.product_medication_info.label_description.atc_segment"
          for="atcSegment"
          [required]="true"
        >
          <lxm-select
            select
            [readonly]="!edit"
            [searchable]="true"
            labelField="title"
            for="atcSegment"
            url="api/clvac/product-level-atc-segments/"
          >
          </lxm-select>
          <validation-errors for="atcSegment"></validation-errors>
          <validation-errors
            for="atcSegmentId"
            aliasTo="atcSegment"
          ></validation-errors>
        </form-field>

        <form-field
          [readonly]="!edit"
          label="cards.products.product_medication_info.label.dosage_form"
          description="cards.products.product_medication_info.label_description.dosage_form"
          for="dosageFormId"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.MedicationDosageForm, form.get('dosageFormId').value)"
        >
          <lxm-select
            select
            [readonly]="!edit"
            [options]="medicationDosageFormOptions"
            [searchable]="true"
            for="dosageFormId"
            value="id"
            labelField="translatedValue"
            [isTranslated]="true"
            [sortByLabel]="true"
          >
          </lxm-select>
          <validation-errors for="dosageFormId"></validation-errors>
        </form-field>

        <form-field
          [readonly]="!edit"
          label="cards.products.product_medication_info.label.prescription_type"
          description="cards.products.product_medication_info.label_description.prescription_type"
          for="prescriptionTypeId"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.MedicationPrescriptionType, form.get('prescriptionTypeId').value)"
        >
          <lxm-select
            select
            [readonly]="!edit"
            [options]="medicationPrescriptionTypeOptions"
            for="prescriptionTypeId"
            value="id"
            labelField="translatedValue"
            [isTranslated]="true"
            [sortByLabel]="true"
          >
          </lxm-select>
          <validation-errors for="prescriptionTypeId"></validation-errors>
        </form-field>

        <form-field
          [readonly]="!edit"
          label="cards.products.product_medication_info.label.has_security_elements"
          description="cards.products.product_medication_info.label_description.has_security_elements"
        >
          <slide-toggle
            toggle
            for="hasSecurityElements"
            [readonly]="!edit"
          ></slide-toggle>
          <validation-errors for="hasSecurityElements"></validation-errors>
        </form-field>
      </div>

      <div class="flex flex-col">
        <form-field
          [readonly]="!edit"
          for="strength"
          label="cards.products.product_medication_info.label.strength"
          description="cards.products.product_medication_info.label_description.strength"
          type="input-text"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.MedicationStrength, form.get('strength').value)"
        >
          <validation-errors for="strength"></validation-errors>
        </form-field>

        <form-field
          [readonly]="!edit"
          label="cards.products.product_medication_info.label.administration_method"
          for="administrationMethods"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.MedicationAdministrationMethods, form.get('administrationMethods').value?.length > 0)"
        >
          <lxm-select
            select
            [readonly]="!edit"
            [options]="medicationAdministrationMethodOptions"
            for="administrationMethods"
            value="id"
            labelField="translatedValue"
            [multiple]="true"
            [searchable]="true"
            [isTranslated]="true"
            [sortByLabel]="true"
          >
          </lxm-select>
          <validation-errors for="administrationMethods"></validation-errors>
        </form-field>

        <form-field
          [readonly]="!edit"
          label="cards.products.product_medication_info.label.addiction_type"
          for="addictionTypeId"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.MedicationAddictionType, form.get('addictionTypeId').value)"
        >
          <lxm-select
            select
            [readonly]="!edit"
            [options]="medicationAddictionTypeOptions"
            for="addictionTypeId"
            value="id"
            labelField="translatedValue"
            [isTranslated]="true"
            [sortByLabel]="true"
          >
          </lxm-select>
          <validation-errors for="addictionTypeId"></validation-errors>
        </form-field>
      </div>
    </div>

    <div class="separator"></div>

    <div class="grid w-full grid-cols-1 gap-4 xl:grid-cols-2">
      <div class="flex flex-col">
        <form-field
          [readonly]="!edit"
          label="cards.products.product_medication_info.label.risk_type"
          for="riskTypeId"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.MedicationRiskType, form.get('riskTypeId').value)"
        >
          <lxm-select
            select
            [readonly]="!edit"
            [options]="medicationRiskTypeOptions"
            for="riskTypeId"
            value="id"
            labelField="translatedValue"
            [searchable]="true"
            [isTranslated]="true"
            [sortByLabel]="true"
          >
          </lxm-select>
          <validation-errors for="riskTypeId"></validation-errors>
        </form-field>

        <form-field
          [readonly]="!edit"
          labelTop="true"
          label="cards.products.product_medication_info.label.risk_description"
          description="cards.products.product_medication_info.label_description.risk_description"
          for="riskDescription"
          [validationResultType]="productValidity.isRequiredByRetailerLanguageText(productField.MedicationRiskDescription)"
        >
          <language-text
            language-text
            for="riskDescription"
            [newline]="true"
            [readonly]="!edit"
            [validationResultType]="productValidity.getLanguageTextRequiredTypes(productField.MedicationRiskDescription)"
          ></language-text>
        </form-field>
      </div>
    </div>
  </div>

  <div footer class="flex flex-row" *ngIf="edit">
    <lxm-button
      class="ml15"
      type="grey"
      icon="back"
      label="action.cancel"
      (click)="toggleEdit()"
    ></lxm-button>
    <lxm-button
      class="ml15"
      type="beige"
      icon="save"
      label="action.save"
      [loading]="saveLoading"
      (click)="save()"
    >
    </lxm-button>
  </div>
</card-expanding>
